import { uiText } from "@/lib/i18n/uiText";
import { useParams } from "@/lib/router-compat";
import { ClusterHub } from "@/components/seo/ClusterHub";
import { findLeagueCluster, leaguePath } from "@/lib/seoClusters";
import { EntityFallback } from "@/components/shared/EntityFallback";
import { titleCaseFromSlug } from "@/lib/entities";
import { leagueCrumbs } from "@/lib/breadcrumbs";

export default function LeagueHub() {
  const { slug = "" } = useParams();
  const cluster = findLeagueCluster(slug);
  if (!cluster)
    return (
      <EntityFallback
        kind="League"
        label={titleCaseFromSlug(slug) || uiText("This league")}
        canonicalPath={`/leagues/${slug}`}
        suggestGroups={["Leagues", "Predictions", "Markets"]}
      />
    );

  return (
    <ClusterHub
      kind="league"
      slug={cluster.slug}
      matchers={cluster.matchers}
      heading={cluster.label}
      title={uiText(cluster.title)}
      description={uiText(cluster.description)}
      intro={cluster.intro}
      canonicalPath={leaguePath(cluster.slug)}
      breadcrumbs={leagueCrumbs(slug, cluster.label)}
    />
  );
}
